'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import { useNotificacoesEquipeInternaPolling } from '@/features/notification-bell/hooks';
import { NavegacaoProtegidaProvider } from '../../contexts/NavegacaoProtegidaContext';
import { AdminSidebar } from './AdminSidebar';
import { AdminTopbar } from './AdminTopbar';
import { useIntegracaoAlertasPolling } from '../../hooks/useIntegracaoAlertasPolling';
import { shouldAutoCollapseSidebar } from '../../utils/autoCollapseRoutes';
import * as SubframeUtils from '@/shared/components/ui/utils';
interface AdminLayoutInnerProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}
export const AdminLayoutInner = React.forwardRef<HTMLDivElement, AdminLayoutInnerProps>(function AdminLayoutInner(t0, ref) {
  const $ = _c(28);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  useIntegracaoAlertasPolling();
  useNotificacoesEquipeInternaPolling();
  const {
    logout
  } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const pathname = usePathname();
  let t1;
  if ($[4] !== pathname) {
    t1 = pathname.startsWith("/admin-geral/flows/editor");
    $[4] = pathname;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const shouldHideSidebar = t1;
  let t2;
  let t3;
  if ($[6] !== pathname) {
    t2 = () => {
      if (shouldAutoCollapseSidebar(pathname)) {
        setIsCollapsed(true);
      }
    };
    t3 = [pathname];
    $[6] = pathname;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== logout) {
    t4 = async () => {
      await logout();
    };
    $[9] = logout;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleLogout = t4;
  let t5;
  if ($[11] !== className) {
    t5 = SubframeUtils.twClassNames("flex h-screen w-full flex-col", className);
    $[11] = className;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== handleLogout || $[14] !== isCollapsed || $[15] !== shouldHideSidebar) {
    t6 = !shouldHideSidebar && <AdminSidebar isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} onLogout={handleLogout} />;
    $[13] = handleLogout;
    $[14] = isCollapsed;
    $[15] = shouldHideSidebar;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== children || $[18] !== shouldHideSidebar) {
    t7 = children ? <div className="flex shrink-0 grow basis-0 flex-col self-stretch overflow-hidden">{!shouldHideSidebar && <AdminTopbar />}<div className="flex min-h-0 grow basis-0 flex-col items-stretch gap-4 overflow-y-auto overscroll-y-contain bg-neutral-50">{children}</div></div> : null;
    $[17] = children;
    $[18] = shouldHideSidebar;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <NavegacaoProtegidaProvider><div className="flex h-full w-full items-center overflow-hidden">{t6}{t7}</div></NavegacaoProtegidaProvider>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== otherProps || $[24] !== ref || $[25] !== t5 || $[26] !== t8) {
    t9 = <div className={t5} ref={ref} {...otherProps}>{t8}</div>;
    $[23] = otherProps;
    $[24] = ref;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
});